import * as actionTypes from "./../../Constants/actionTypes";
import lookupUtility from "./../../Common/Utility/LookUpDataMapping";
import API from "./../../Constants/API";
import * as requestServices from "../../services/request";
var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }

    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}
const FIRM_ID = userDetails ? userDetails.UserContext.firmId : 847;

let _allprofile_lookup = _res => {
  return {
    type: actionTypes.GET_USER_LOOKUPS,
    payload: _res
  };
};
let _getuserprofile_data = _res => {
  return {
    type: actionTypes.GET_USER_DETAILS,
    payload: _res
  };
};
let _formprofile_object = _res => {
  return {
    type: actionTypes.PUT_USER_DETAILS,
    payload: _res
  };
};
let _insertformprofile_object = _res => {
  return {
    type: actionTypes.POST_USER_DETAILS,
    payload: _res
  };
};
let _change_statusobject = () => {
  return {
    type: actionTypes.CHANGE_STATUS,
    payload: "new"
  };
};
let _change_mycalenderobject = (_res) => {
  return {
    type: actionTypes.MYCALENDER_BUCKET,
    payload: _res
  };
};
export const _load_userlookups = () => {
  try {
    return dispatch => {
      requestServices.get(API.getLookup + "/" + FIRM_ID)
        .then(res => {
          // console.log("Response", res);
          dispatch(_allprofile_lookup(res));
        })
        .catch(err => {
          console.log("Error", err);
          window.location.href = "/webapp/notauth";
          dispatch(_allprofile_lookup({}));
        });
    };

  } catch (e) {
    console.log("actionType-->_load_userlookups", e);
  }
};
const getEncodedValue = (input) => {
    let doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
};
export const _post_userdata = (_obj, _props) => {
  try {
      return dispatch => {
          let _res = lookupUtility.UserInsertObject(_obj, _props);
          _res.first_name = getEncodedValue(_res.first_name);
          _res.last_name = getEncodedValue(_res.last_name);
          _res.middle_name = getEncodedValue(_res.middle_name);
          _res.employee_id = getEncodedValue(_res.employee_id);
      requestServices.post(API.createUser, _res)
        .then(res => {
          console.log("Response", res);
          dispatch(_insertformprofile_object(res));
        })
        .catch(err => {
          console.log("Error", err);
        });
    };
  } catch (e) {
    console.log("actionType-->_post_userdata", e);
  }
};

export const _update_userdata = (_obj, _props) => {
    try {
    return dispatch => {
        let _res = lookupUtility.UserInsertObject(_obj, _props);
        _res.first_name = getEncodedValue(_res.first_name);
        _res.last_name = getEncodedValue(_res.last_name);
        _res.middle_name = getEncodedValue(_res.middle_name);
        _res.employee_id = getEncodedValue(_res.employee_id);
       
      requestServices.put(API.updateUser, _res)
        .then(res => {
          dispatch(_formprofile_object(res));
        })
        .catch(err => {
          console.log("Error", err);
        });
    };
  } catch (e) {
    console.log("actionType-->_update_userdata", e);
  }
};

export const _get_userdetails = _id => {
  return dispatch => {
    requestServices.get(API.getIndividualUserDetails + "/" + _id)
      .then(res => {
        dispatch(_getuserprofile_data(res));
      })
      .catch(err => {
        dispatch(_getuserprofile_data(0));
      });
  };
};
export const _change_status = () => {
  return dispatch => {
    setTimeout(() => {
      dispatch(_change_statusobject());
    }, 3000);
  };
};
export const _mycalender_bucket = (_action) => {
  return dispatch => {   
      dispatch(_change_mycalenderobject(_action));   
  };
};

